import { render, staticRenderFns } from "./CompaniesCreate.vue?vue&type=template&id=1e72311a&"
import script from "./CompaniesCreate.vue?vue&type=script&lang=js&"
export * from "./CompaniesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports